import React from 'react';

// Stats to display and their human readable labels
const STATS = [
  { key: 'sig_land_per_min',      label: 'Sig. Strikes / Min',    decimals: 2 },
  { key: 'sig_strike_acc',        label: 'Strike Accuracy',       decimals: 2, pct: true },
  { key: 'sig_absorbed_per_min',  label: 'Strikes Absorbed / Min',decimals: 2, lower_better: true },
  { key: 'kd_per_min',            label: 'Knockdowns / Min',      decimals: 3 },
  { key: 'takedown_land_per_min', label: 'Takedowns / Min',       decimals: 2 },
  { key: 'takedown_perc',         label: 'Takedown Accuracy',     decimals: 2, pct: true },
  { key: 'sub_att_per_min',       label: 'Sub Attempts / Min',    decimals: 2 },
  { key: 'ctrl_time_per_min',     label: 'Ctrl Time / Min',       decimals: 2 },
  { key: 'finish_rate',           label: 'Finish Rate',           decimals: 2, pct: true },
];

function StatBar({ stat, f1Stats, f2Stats }) {
  const f1Val = parseFloat(f1Stats?.[stat.key]) || 0;
  const f2Val = parseFloat(f2Stats?.[stat.key]) || 0;
  const max   = Math.max(f1Val, f2Val, 0.001);

  const f1Pct = (f1Val / max) * 100;
  const f2Pct = (f2Val / max) * 100;

  // Determine winner — for lower_better stats, lower value wins
  const f1Wins = stat.lower_better ? f1Val < f2Val : f1Val > f2Val;
  const f2Wins = stat.lower_better ? f2Val < f1Val : f2Val > f1Val;

  function fmt(val) {
    if (stat.pct) return `${(val * 100).toFixed(0)}%`;
    return val.toFixed(stat.decimals);
  }

  return (
    <div className="stat-row">
      {/* F1 side */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'flex-end' }}>
        <span className={`stat-val-f1 ${f1Wins ? 'winner' : ''}`}>{fmt(f1Val)}</span>
        <div className="stat-bar-wrap" style={{ width: 80 }}>
          <div className="stat-bar-f1" style={{ width: `${f1Pct}%` }} />
        </div>
      </div>

      {/* Label */}
      <div className="stat-label">{stat.label}</div>

      {/* F2 side */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div className="stat-bar-wrap f2" style={{ width: 80 }}>
          <div className="stat-bar-f2" style={{ width: `${f2Pct}%` }} />
        </div>
        <span className={`stat-val-f2 ${f2Wins ? 'winner' : ''}`}>{fmt(f2Val)}</span>
      </div>
    </div>
  );
}

export default function StatComparison({ stats1, stats2, fighter1, fighter2 }) {
  return (
    <div className="card">
      <h2>Stats Comparison</h2>

      {/* Column headers */}
      <div className="stat-row" style={{ marginBottom: 18 }}>
        <div style={{ textAlign: 'right', fontSize: 13, fontWeight: 600, color: '#e8372a' }}>
          {fighter1?.full_name}
        </div>
        <div />
        <div style={{ textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#2563eb' }}>
          {fighter2?.full_name}
        </div>
      </div>

      {STATS.map(stat => (
        <StatBar
          key={stat.key}
          stat={stat}
          f1Stats={stats1?.All}
          f2Stats={stats2?.All}
        />
      ))}
    </div>
  );
}
